module.exports = __webpack_public_path__ + "static/media/python_stepik_character3.d1308f82.png";